const KARHOO_TAXI_UPDATED = (state, KarhooTaxi) => {
  state.KarhooTaxi = KarhooTaxi
}

export default {
  KARHOO_TAXI_UPDATED
}
